module.exports = __webpack_public_path__ + "img/logo1.128df252.svg";